export default __webpack_public_path__ + "static/media/google-play-badge.f06abeb9.svg";